// src-crsld/config.js

var crsldDevConfig = {
  production: false,
  appName: 'mrs',
  pubPath: 'crsld',
  baseURL: 'http://localhost:8086/',
  media: "https://media.mirasee/",
  api: "https://api.mirasee/v2/",
  apiv3: "https://api.mirasee/v3/",
  opform: 'page/op/ruzuku/form/'
};

var crsldProdConfig = {
  production: true,
  appName: 'mrs',
  pubPath: 'views',
  baseURL: 'https://courseladders.com/',
  media: "https://media.mirasee.com/",
  api: "https://api.mirasee.com/v2/",
  apiv3: "https://api.mirasee.com/v3/",
  opform: 'page/op/ruzuku/form/'
};

if (process.env.NODE_ENV == 'development')
  var crsldConfig = crsldDevConfig;
else
  crsldConfig = crsldProdConfig;

export default crsldConfig;
